import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import React from "react";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import CreateForm from "./CreateForm";

const CreateHub = () => {
  const { t } = useTranslation(["hub"]);

  return (
    <div className="page-content">
      <MetaTags>
        <title>{t("title.create")}</title>
      </MetaTags>
      <div className="container-fluid">
        <BreadcrumbWithLink
          title={t("title.create")}
          breadcrumbItems={[
            { name: t("title.manager") },
            { name: t("title.list", { target: t("hub") }), link: "/hub/list" },
            { name: t("title.create") },
          ]}
        />
        <CreateForm />
      </div>
    </div>
  );
};

export default CreateHub;
